<template>
    <div class="flex items-center justify-center" style="height: 100vh;">
        <div>
            <div class="text-3xl font-bold">
                404
            </div>
            <div class="text-xl">
                Page introuvable
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>

</style>
